/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
export type personaPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null };

export const personaPerson = gql`
    fragment personaPerson on CreditApplicationPerson {
  id
  firstName
  lastName
  email
}
    `;